import ListMultipleSelectionInterface from '@/components/list-multiple-selection/list-multiple-selection.interface';

export default class Justify implements ListMultipleSelectionInterface {
  id: string;

  name: string;

  dateCustom?: boolean;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.dateCustom = obj.dateCustom || false;
  }

  public static of(obj: any): Justify {
    return new Justify(obj || {});
  }

  public static ofList(obj: any = []): Justify[] {
    return obj.map(this.of);
  }

  public canUseCustomDate(): boolean {
    return this.dateCustom || false;
  }
}
